import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex flex-col flex-1 pb-28 w-full h-full bg-white"
};
const _hoisted_2 = {
  class: "flex justify-between items-center pl-4 pr-24"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "relative my-1 rounded-md shadow-sm"
};
const _hoisted_5 = {
  class: "flex-1 print:overflow-hidden"
};
const _hoisted_6 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_7 = {
  key: 0,
  class: "m-6 text-xs text-gray-800"
};
const _hoisted_8 = {
  key: 1,
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_9 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "no-print py-3 px-6"
};
const _hoisted_14 = {
  class: "ll-menu dropdown"
};
const _hoisted_15 = {
  class: "dropdown-menu"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "flex flex-row-reverse px-8 py-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_distribution_status_modal = _resolveComponent("distribution-status-modal");
  const _component_update_distributionModal = _resolveComponent("update-distributionModal");
  const _component_pagination = _resolveComponent("pagination");
  return $setup.loading ? (_openBlock(), _createBlock(_component_loader, {
    key: 0,
    what: 'Distribution',
    class: "mt-32"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", null, [_createElementVNode("h3", null, "Distributions")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_LlSecondaryButton, {
    icon: "mdi-filter",
    variant: "text",
    class: "no-print",
    color: $setup.distributionStore.distributionParms.statusId !== 'all' ? 'primary' : undefined,
    "aria-label": "Filter distributions by status",
    onClick: _cache[0] || (_cache[0] = $event => $setup.showDistributionStatusModal())
  }, null, 8, ["color"]), _createVNode(_component_distribution_status_modal), _createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "flex absolute inset-y-0 left-0 items-center pt-1 pl-3 pointer-events-none",
    "aria-hidden": "true"
  }, [_createElementVNode("svg", {
    class: "mr-3 w-4 h-4 text-gray-400",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
    "clip-rule": "evenodd"
  })])], -1)), _withDirectives(_createElementVNode("input", {
    type: "search",
    name: "search",
    id: "search",
    class: "block w-full",
    placeholder: "Search Distribution",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.query = $event)
  }, null, 512), [[_vModelText, $setup.query]])])])]), $setup.distributionNavigationStore.showUpdateDistributionModal ? (_openBlock(), _createBlock(_component_update_distributionModal, {
    key: 0
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [!$setup.distributionStore.distributionsList.distributions?.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No Distribution match the filters ")) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[2] || (_cache[2] = $event => $setup.distributionStore.sort('name'))
  }, " Name "), _cache[6] || (_cache[6] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Status ", -1)), _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[3] || (_cache[3] = $event => $setup.distributionStore.sort('created'))
  }, " Created "), _cache[7] || (_cache[7] = _createElementVNode("th", null, null, -1))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.distributionStore.distributionsList.distributions, (distribution, idx) => {
    return _openBlock(), _createElementBlock("tr", {
      key: idx
    }, [_createElementVNode("td", {
      class: "cursor-pointer py-3 px-6",
      onClick: $event => $setup.openDistributionDetail(distribution)
    }, _toDisplayString(distribution.label), 9, _hoisted_10), _createElementVNode("td", {
      class: "cursor-pointer py-3 px-6",
      onClick: $event => $setup.openDistributionDetail(distribution)
    }, _toDisplayString(distribution.status), 9, _hoisted_11), _createElementVNode("td", {
      class: "cursor-pointer py-3 px-6",
      onClick: $event => $setup.openDistributionDetail(distribution)
    }, _toDisplayString(_ctx.formatDate(distribution.date)), 9, _hoisted_12), _createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[8] || (_cache[8] = _createElementVNode("span", {
      class: "dropdown-toggle",
      "data-toggle": "dropdown"
    }, [_createElementVNode("i", {
      class: "fa fa-ellipsis-v"
    })], -1)), _createElementVNode("ul", _hoisted_15, [_createElementVNode("li", null, [_createElementVNode("span", {
      class: "menuitem",
      onClick: $event => $setup.editDistribution(distribution)
    }, "Edit Distribution", 8, _hoisted_16)]), _createElementVNode("li", null, [_createElementVNode("span", {
      class: "menuitem",
      onClick: $event => $setup.openDistributionDetail(distribution)
    }, "Open Distribution Detail", 8, _hoisted_17)])])])])]);
  }), 128))])])]))])]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createVNode(_component_pagination, {
    "total-pages": $setup.distributionStore.distributionsTotalPages,
    totalItems: $setup.distributionStore.distributionsList?.pagination?.total || 0,
    offset: $setup.distributionStore.distributionsList?.pagination?.offset || 0,
    "per-page": $setup.distributionStore.distributionsList.perPage,
    "current-page": $setup.distributionStore.distributionsList.currentPage,
    "open-direction": 'top',
    onPagechanged: $setup.distributionStore.onPageChange
  }, null, 8, ["total-pages", "totalItems", "offset", "per-page", "current-page", "onPagechanged"]), [[_vShow, $setup.distributionStore.distributionsTotalPages > 1]])])]));
}